import React from 'react'

export default function HeroSec() {
    return (
        <div className="hero mt-24 max-sm:h-[90vh] max-sm:mt-0">
            <div className="hero-content text-center">
                <div className="w-[60vw] max-sm:w-full max-sm:text-left">
                    <h1 className="text-5xl font-bold text-primary max-sm:text-3xl">Master CSS Specificity and Understand the Priority Hierarchy for Effortless Styling</h1>
                    <p className="py-6">
                        Discover how CSS rules, selectors, and specificity work together to optimize your web designs and improve your workflow.
                    </p>
                    {/* <button className="btn btn-primary">Get Started</button> */}
                </div>
            </div>
        </div>
    )
}
